import { FaArrowLeft, FaArrowRight, FaEdit, FaClock, FaUser, FaPlus, FaChevronDown, FaPlay, FaFileAlt, FaChartBar } from "react-icons/fa";
import ZynthLogoText from '../../assets/zynth-text.png'
import { useNavigate, useLocation } from 'react-router-dom'
import { useState, useEffect, useRef } from 'react'
import { openPricing } from '../../utils/openPricing'
import { Plan } from '../../types/pricingTypes'
import axios from 'axios'
import { IpInfoResponse } from '../../types/authTypes'
import GuidedTour from '../onboarding/shared/GuidedTour'
import GuidedTourMobile from '../onboarding/shared/GuidedTourMobile'
import { useCredits } from '../../hooks/useCredits'

import zynthtext from "../../assets/zynth-text.png";
interface NavbarProps {
  showHistoryId?: boolean // Add a prop to control the "history" ID
  showOrganizationProfileId?: boolean // Add a prop to control the "organization-profile" ID
}

const Navbar: React.FC<NavbarProps> = ({
  showHistoryId,
  showOrganizationProfileId,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [monthlyPlan, setMonthlyPlan] = useState<Plan>()
  const [yearlyPlan, setYearlyPlan] = useState<Plan>()
  const authToken = sessionStorage.getItem('authToken')
  const orgId = sessionStorage.getItem('orgId')
  // pricing modal removed — use external pricing page
  const userProfileImage = sessionStorage.getItem('userDP')
  const [currency, setCurrency] = useState<string>()
  const userProfileRef = useRef<HTMLDivElement | null>(null) // Reference to the profile image to handle click toggles
  const [subId, setSubId] = useState('')
  const [newMenuOpen, setNewMenuOpen] = useState(false);
  const navigate = useNavigate()
  const { credits, loading: creditsLoading } = useCredits()
  // Get current location
  const location = useLocation()

  const handleLogout = () => {
    sessionStorage.clear()
    navigate('/')
  }
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const [open, setOpen] = useState(false);
  // Close dropdown when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Ensure dropdownRef is not null and contains the clicked target
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        userProfileRef.current &&
        !userProfileRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false) // Close dropdown if clicked outside
      }
    }

    // Add event listener to document
    document.addEventListener('mousedown', handleClickOutside)

    // Cleanup the event listener when the component is unmounted or when dropdown state changes
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, []) // Empty dependency array ensures this effect runs once

  // API CALL TO GET PRICING DATA FOR MODAL
  useEffect(() => {
    const getPricingData = async () => {
      try {
        const ipInfoResponse = await fetch(
          'https://api.zynth.ai/api/v1/data/userprofile/ip-info'
        )
        const ipInfoData: IpInfoResponse = await ipInfoResponse.json()

        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/payments/razorpay/plans`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        )

        const country = ipInfoData!.country!
        if (country !== 'IN' && country !== 'India' && country !== 'In') {
          setMonthlyPlan(response.data.items[5])
          setYearlyPlan(response.data.items[6])
          setCurrency('USD')
        } else {
          setMonthlyPlan(response.data.items[8])
          setYearlyPlan(response.data.items[7])
          setCurrency('INR')
        }
      } catch (error) {
        console.error('Error fetching pricing data:', error)
      }
    }

    const fetchUserPlan = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        )
        const subscriptionId = response.data.plan.subscriptionId
        setSubId(subscriptionId)
      } catch (error) {
        console.error('Error fetching user plan:', error)
      }
    }

    fetchUserPlan()

    const timer = setTimeout(() => {
      getPricingData()
    }, 3000) // delay

    // Cleanup the timer in case the component unmounts
    return () => clearTimeout(timer)
  }, [])
  const monthlyPlanAmount = monthlyPlan?.item.amount! / 100
  const monthlyPlanId = monthlyPlan?.id
  const yearlyPlanAmount = yearlyPlan?.item.amount! / 100
  const yearlyPlanId = yearlyPlan?.id

  const toggleDropdown = () => {
    setDropdownOpen((prevState) => !prevState) // Toggle dropdown state
  }

 return (
    <nav className="w-full bg-white">
  {/* Full width wrapper */}
  <div className="w-full px-3 sm:px-4 md:px-6 lg:px-10">
    {/* Navbar content */}
    <div className="flex items-center justify-between h-[3.5rem] lg:h-[4rem] w-full">

      
        <div className="text-xl font-bold text-gray-800">
          <span className="flex items-center">
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-all duration-300 transform hover:scale-110 active:scale-95 active:opacity-80"
            >
              <img className="h-8" src={zynthtext} alt="Zynth" />
            </a>
          </span>
        </div>

        {/* Menu */}
       <div className="hidden md:flex items-center justify-center flex-1 min-w-0 space-x-3 px-2 lg:space-x-4 xl:space-x-10 lg:px-3">


          {/* Conditionally hide the "New Presentation" button on '/new-presentation' */}
        
          <div className="relative group">
            {/* Trigger Button */}
            <button
              className="bg-white lg:h-[2.5rem] border-[#3667B2] border text-[#3667B2] hover:bg-[#3667B2] hover:text-white hover:border-[#3667B2] hover:border text-base font-medium px-3 py-2 lg:py-2 rounded-md active:scale-95 transition transform duration-300"
            >
              <span className="sm:hidden text-base">
                <FaPlus />
              </span>
              <span className="hidden sm:flex items-center space-x-2">
                <FaPlus />
                <span>New</span>
              </span>
            </button>

            {/* Dropdown (Hover) */}
            <div
              className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border z-50
              opacity-0 invisible group-hover:opacity-100 group-hover:visible
              transition-all duration-200"
            >
              <button
                onClick={() => navigate("/new-presentation")}
                className="flex items-center gap-3 w-full px-4 py-3 text-md text-gray-700 hover:bg-gray-100"
              >
                <FaChartBar className="text-[#3667B2]" />
                <span>New Presentation</span>
              </button>

              {/* New Document */}
              <button
                onClick={() => navigate("/new-document")}
                className="flex items-center gap-3 w-full px-4 py-3 text-md text-gray-700 hover:bg-gray-100"
              >
                <FaFileAlt className="text-[#3667B2]" />
                <span>New Document</span>
              </button>
            </div>
          </div>

          {/* <a
            className="text-[#5D5F61] hover:text-blue-600 transition-colors duration-200"
            onClick={(e) => {
              e.preventDefault();
              window.open("https://pitch.zynth.ai/", "_blank", "noopener,noreferrer");
            }}
          >
            AI Pitch Builder
          </a> */}

          <a
            onClick={() =>
              window.open(
                "https://extension.zynth.ai/",
                "_blank",
                "noopener,noreferrer"
              )
            }
            className="text-[#5D5F61] hover:text-blue-600 transition-colors duration-200 cursor-pointer"
          >
            Google Slides Add On
          </a>

          <a
            onClick={() => window.open("/apiReference", "_blank")}
            className="text-[#5D5F61] hover:text-blue-600 transition-colors duration-200 cursor-pointer"
          >
            API Reference
          </a>

          <button
            id={showHistoryId ? 'history' : undefined}
            onClick={() => navigate('/history')}
            className="bg-white lg:h-[2.5rem] border-[#3667B2] border text-[#3667B2] hover:bg-[#3667B2] hover:text-white hover:border-[#3667B2] hover:border text-base font-medium px-3 py-2 lg:py-2 rounded-md active:scale-95 transition transform duration-300"
          >
            <span className="sm:hidden text-base">
              <FaClock />
            </span>
            <span className="hidden sm:flex items-center space-x-2">
              <FaClock />
              <span>History</span>
            </span>
          </button>
        </div>

        {/* Mobile Menu - Icons with Tooltips */}
        <div className="flex md:hidden items-center space-x-3">
          {/* New Button - Mobile */}
          <div className="relative group">
            <button
              onClick={() => setNewMenuOpen(!newMenuOpen)}
              className="bg-white border-[#3667B2] border text-[#3667B2] hover:bg-[#3667B2] hover:text-white p-2 rounded-md active:scale-95 transition transform duration-300"
            >
              <FaPlus className="text-base" />
              {/* Tooltip */}
              <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
                New
              </span>
            </button>

            {/* Mobile Dropdown for New */}
            {newMenuOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border z-50">
                <button
                  onClick={() => {
                    navigate("/new-presentation");
                    setNewMenuOpen(false);
                  }}
                  className="flex items-center gap-3 w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <FaChartBar className="text-[#3667B2]" />
                  <span>New Presentation</span>
                </button>
                <button
                  onClick={() => {
                    navigate("/new-document");
                    setNewMenuOpen(false);
                  }}
                  className="flex items-center gap-3 w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <FaFileAlt className="text-[#3667B2]" />
                  <span>New Document</span>
                </button>
              </div>
            )}
          </div>

          {/* History Button - Mobile */}
          <button
            id={showHistoryId ? 'history' : undefined}
            onClick={() => navigate('/history')}
            className="group relative bg-white border-[#3667B2] border text-[#3667B2] hover:bg-[#3667B2] hover:text-white p-2 rounded-md active:scale-95 transition transform duration-300"
          >
            <FaClock className="text-base" />
            {/* Tooltip */}
            <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
              History
            </span>
          </button>
          {/* Credits indicator (mobile) */}
          <div className="flex items-center gap-2">
            {!creditsLoading ? (
              <div className="text-sm text-gray-700">{credits ?? 0}</div>
            ) : (
              <div className="text-sm text-gray-500">--</div>
            )}
            <button
              onClick={() => {
                const orgIdParam = sessionStorage.getItem('orgId') || ''
                const userIdParam = sessionStorage.getItem('userId') || ''
                const url = `/pricing?from=header&orgId=${encodeURIComponent(
                  orgIdParam
                )}&userId=${encodeURIComponent(userIdParam)}`
                window.open(url, '_blank')
              }}
              className="px-2 py-1 bg-blue-600 text-white rounded-md"
            >
              Buy Credits
            </button>
          </div>
        </div>

        {/* Header credits indicator (desktop/tablet) */}
        <div className="hidden md:flex items-center gap-3 mr-4">
          {!creditsLoading ? (
            <div className="text-sm text-gray-700">
              Credits: <span className="font-semibold">{credits ?? 0}</span>
            </div>
          ) : (
            <div className="text-sm text-gray-500">Credits: --</div>
          )}
          <button
            onClick={() => {
              const orgIdParam = sessionStorage.getItem('orgId') || ''
              const userIdParam = sessionStorage.getItem('userId') || ''
              const url = `/pricing?from=header&orgId=${encodeURIComponent(
                orgIdParam
              )}&userId=${encodeURIComponent(userIdParam)}`
              window.open(url, '_blank')
            }}
            className="px-3 py-1 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Buy Credits
          </button>
        </div>

        {/* User Profile Icon */}
        <div
          id={showOrganizationProfileId ? 'organization-profile' : undefined}
          ref={userProfileRef}
          className="group relative"
        >
          {userProfileImage ? (
            <img
              src={userProfileImage}
              alt="User Profile"
              className="w-11 h-11 lg:w-11 lg:h-11 rounded-full hover:scale-105 cursor-pointer"
              onClick={toggleDropdown}
            />
          ) : (
            <FaUser
              className="w-11 h-11 lg:w-10 lg:h-10 rounded-full hover:scale-105 cursor-pointer"
              onClick={toggleDropdown}
            />
          )}
          {/* Tooltip for Profile */}
          <span className="lg:hidden absolute -bottom-8 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
            Profile
          </span>
        </div>

        {/* Dropdown */}
        {dropdownOpen && (
          <div
            ref={dropdownRef}
            className="fixed top-20 lg:top-17 right-2 lg:right-4 bg-white shadow-lg rounded-md p-2 w-48 h-auto"
            style={{ zIndex: 2147483647, position: 'fixed' }}
            onClick={() => setDropdownOpen(false)}
          >
            <button
              onClick={() => navigate('/organization-profile')}
              className="w-full text-[#5D5F61] text-left text-sm py-1 px-4 hover:bg-gray-100 overflow-hidden text-ellipsis whitespace-nowrap"
            >
              Organization Profile
            </button>
            <button
              onClick={() => openPricing('header')}
              className="w-full text-[#5D5F61] text-left text-sm py-1 px-4 hover:bg-gray-100 overflow-hidden text-ellipsis whitespace-nowrap"
            >
              Subscription Plans
            </button>
            <button
              onClick={() => navigate('/refer')}
              className="w-full text-[#5D5F61] text-left text-sm py-1 px-4 hover:bg-gray-100 overflow-hidden text-ellipsis whitespace-nowrap"
            >
              Refer & Earn
            </button>
            <button 
              onClick={() => navigate('/invoice')}
              className="w-full text-[#5D5F61] text-left text-sm py-1 px-4 hover:bg-gray-100 overflow-hidden text-ellipsis whitespace-nowrap"
            >
              Invoices
            </button>
            <button
              className="w-full text-[#5D5F61] text-left text-sm py-1 px-4 hover:bg-gray-100 overflow-hidden text-ellipsis whitespace-nowrap"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        )}
      </div>

      {/* Pricing Modal */}
      {/* Pricing modal removed — redirect to the /pricing page in a new tab instead */}
      <GuidedTour />
      <GuidedTourMobile />
      </div>
    </nav>
  )
}

export default Navbar